var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.771,
    height: 2.872,
    viewBox: "0 0 20.771 18.708",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_668",
    "data-name": "Raggruppa 668",
    transform: "translate(-742 -1330.254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_667",
    "data-name": "Raggruppa 667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_666",
    "data-name": "Raggruppa 666"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1272",
    "data-name": "Tracciato 1272",
    d: "M13,4.416a1.15,1.15,0,0,0-1.991,0L3.474,17.424a1.15,1.15,0,0,0,1,1.726H19.531a1.15,1.15,0,0,0,1-1.726ZM9.534,3.564a2.85,2.85,0,0,1,4.933,0L22,16.572a2.85,2.85,0,0,1-2.466,4.278H4.469A2.85,2.85,0,0,1,2,16.572ZM12,8.15a.85.85,0,0,1,.85.85v4a.85.85,0,0,1-1.7,0V9A.85.85,0,0,1,12,8.15ZM12,17a1,1,0,1,0-1-1A1,1,0,0,0,12,17Z",
    transform: "translate(740.385 1328.112)",
    fill: "#e03625",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.88a1812afa84dd623842ae36480c8e55.svg";
export { ForwardRef as ReactComponent };